import { Navbar } from "./components/Navbar";
import { HeroContent } from "./components/HeroContent";
import { HowItWorks } from "./components/HowItWorks";
import "./index.css";

const VIDEO_SRC =
  "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260217_030345_246c0224-10a4-422c-b324-070b7c0eceda.mp4";

export function App() {
  return (
    <div className="relative min-h-screen bg-black">
      {/* Video background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="fixed inset-0 z-0 h-full w-full object-cover"
      >
        <source src={VIDEO_SRC} type="video/mp4" />
      </video>

      {/* Black overlay */}
      <div className="fixed inset-0 z-10 bg-black/50" />

      {/* Page content */}
      <div className="relative z-20 flex min-h-screen flex-col">
        <div className="px-6 md:px-[120px]">
          <Navbar />
        </div>

        <div className="flex flex-1 items-center justify-center">
          <HeroContent />
        </div>

        <HowItWorks />
      </div>
    </div>
  );
}
